/* Rituals by Sakinah - commerce layer.
   Progressive enhancement only: the page is complete and sellable without this file.
   Motion lives in rituals-a.js / rituals-b.js, never here. */
(function () {
  'use strict';

  var money = function (cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return 'R' + amount;
  };

  var pushEvent = function (payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  var toastEl = null;
  var toastTimer = null;
  var toast = function (message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rituals-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  };

  var refreshHeaderCartCount = function (cart) {
    document.querySelectorAll('[data-cart-count], .hdt-cart-count, .cart-count-bubble span').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  };

  /* ---------- AJAX add to cart ---------- */
  var addToCart = function (form) {
    var button = form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    if (button) button.setAttribute('disabled', 'disabled');
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (result) {
        if (!result.ok) {
          toast(result.json.description || result.json.message || 'Could not add to cart');
          return null;
        }
        var item = result.json;
        pushEvent({
          event: 'add_to_cart',
          ecommerce: {
            currency: 'ZAR',
            value: item.final_price / 100,
            items: [{
              item_id: String(item.variant_id),
              item_name: item.product_title,
              item_variant: item.variant_title,
              price: item.final_price / 100,
              quantity: item.quantity
            }]
          }
        });
        if (button) {
          var original = button.textContent;
          button.classList.add('is-added');
          button.textContent = button.getAttribute('data-added-label') || 'Added';
          setTimeout(function () {
            button.classList.remove('is-added');
            button.textContent = original;
          }, 2200);
        }
        toast((item.product_title || 'Item') + ' added to cart');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) {
          refreshHeaderCartCount(cart);
          updateSummary(cart);
          document.dispatchEvent(new CustomEvent('rituals:cart-updated', { detail: cart }));
        }
      })
      .catch(function () {
        toast('Could not add to cart. Please try again.');
      })
      .then(function () {
        if (button) button.removeAttribute('disabled');
      });
  };

  document.querySelectorAll('form[data-rituals-atc]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addToCart(form);
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('.rituals-qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-step') === 'down' ? -1 : 1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
      });
    });
  });

  /* ---------- Design picker (set section) ---------- */
  var setSection = document.querySelector('[data-rituals-set]');
  var currentDesign = null;

  var syncSticky = function () {
    var sticky = document.querySelector('[data-rituals-sticky]');
    if (!sticky || !currentDesign) return;
    sticky.querySelector('[data-sticky-name]').textContent = currentDesign.getAttribute('data-design-title');
    sticky.querySelector('[data-sticky-price]').textContent = currentDesign.getAttribute('data-design-price');
    var stickyBtn = sticky.querySelector('button');
    var available = currentDesign.getAttribute('data-design-available') === 'true';
    stickyBtn.disabled = !available;
    stickyBtn.textContent = available ? (stickyBtn.getAttribute('data-label') || 'Add to cart') : (stickyBtn.getAttribute('data-soldout-label') || 'Sold out');
  };

  if (setSection) {
    var panels = setSection.querySelectorAll('.rituals-set__panel');
    var radios = setSection.querySelectorAll('.rituals-set__picker input');

    var activate = function (handle) {
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-design-handle') === handle;
        panel.classList.toggle('is-active', active);
        if (active) currentDesign = panel;
      });
      syncSticky();
    };

    if (panels.length && radios.length) {
      setSection.setAttribute('data-enhanced', '');
      var checked = setSection.querySelector('.rituals-set__picker input:checked') || radios[0];
      checked.checked = true;
      activate(checked.value);
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () { activate(radio.value); });
      });
    }

    /* Gallery thumb swapping */
    setSection.querySelectorAll('.rituals-gallery').forEach(function (gallery) {
      var main = gallery.querySelector('.rituals-gallery__main img');
      gallery.querySelectorAll('.rituals-gallery__thumbs img').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.getAttribute('data-full') || thumb.src;
          main.srcset = thumb.getAttribute('data-full-srcset') || '';
          gallery.querySelectorAll('.rituals-gallery__thumbs img').forEach(function (t) { t.classList.remove('is-current'); });
          thumb.classList.add('is-current');
        });
      });
    });

    /* view_item when the set section enters the viewport */
    if ('IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !seen) {
            seen = true;
            observer.disconnect();
            var panel = currentDesign || panels[0];
            if (panel) {
              pushEvent({
                event: 'view_item',
                ecommerce: {
                  currency: 'ZAR',
                  value: parseFloat(panel.getAttribute('data-design-price-number') || '0'),
                  items: [{
                    item_id: panel.getAttribute('data-design-id'),
                    item_name: panel.getAttribute('data-design-title')
                  }]
                }
              });
            }
          }
        });
      }, { threshold: 0.35 }).observe(setSection);
    }
  }

  /* ---------- Sticky mobile bar ---------- */
  var sticky = document.querySelector('[data-rituals-sticky]');
  if (sticky && setSection && 'IntersectionObserver' in window) {
    var stickyBtnEl = sticky.querySelector('button');
    if (stickyBtnEl) {
      stickyBtnEl.addEventListener('click', function () {
        if (!currentDesign) return;
        var form = currentDesign.querySelector('form[data-rituals-atc]');
        if (form) addToCart(form);
      });
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        /* Show once the visitor has scrolled past the set section, keep to page end */
        var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        if (passed) {
          sticky.removeAttribute('hidden');
          syncSticky();
        } else if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
          sticky.setAttribute('hidden', '');
        }
      });
    }, { threshold: 0 }).observe(setSection);
  }

  /* ---------- Running "your ritual" summary + threshold ---------- */
  var summary = document.querySelector('[data-rituals-summary]');
  var updateSummary = function (cart) {
    if (!summary || !cart) return;
    if (!cart.item_count) {
      summary.classList.remove('is-visible');
      return;
    }
    summary.classList.add('is-visible');
    summary.querySelector('[data-summary-items]').textContent =
      cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    summary.querySelector('[data-summary-total]').textContent = money(cart.total_price);
    var thresholdEl = summary.querySelector('[data-summary-threshold]');
    if (thresholdEl) {
      var threshold = parseInt(thresholdEl.getAttribute('data-threshold-cents'), 10) || 0;
      var template = thresholdEl.getAttribute('data-threshold-message') || '';
      var reached = thresholdEl.getAttribute('data-threshold-reached') || '';
      if (threshold > 0) {
        if (cart.total_price >= threshold) {
          thresholdEl.textContent = reached;
        } else {
          thresholdEl.textContent = template.replace('[amount]', money(threshold - cart.total_price));
        }
      }
    }
  };
  if (summary) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(updateSummary)
      .catch(function () {});
  }

  /* ---------- Chapter scroll completion event ---------- */
  var lastChapter = document.querySelector('[data-rituals-chapter]:last-of-type');
  if (lastChapter && 'IntersectionObserver' in window) {
    var completed = false;
    new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !completed) {
          completed = true;
          observer.disconnect();
          pushEvent({ event: 'rituals_chapters_complete' });
        }
      });
    }, { threshold: 0.6 }).observe(lastChapter);
  }
})();
